export class SavedValues {
  projectDescriptionSelectedIndex: number;

  constructor() {
    this.projectDescriptionSelectedIndex = 3;
  }
}
